<template>
    <div>
        <v-flex xs12 sm12 d-block class="card-dados">
            <h3 class="card-dados__titulo mb-0">Declaração de Ciência</h3>

            <v-list>
                <v-list-tile class="lista">
                    <v-list-tile-content>
                        <v-list-tile-title>
                            <span class="bolinha">1</span>
                            Termo de Aceite
                            <span class="red--text">*</span>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                            <v-checkbox name="Termo de Aceite"
                                        :label="`Declaro que estou ciente e concordo com as condições contidas na compra direta eletrônica.`"
                                        v-model="valor.aceiteTermo"
                                        v-validate="'required:true'"
                                        :error-messages="errors.collect('Termo de Aceite')"
                                        :disabled="propostaEnviada"
                                        @change="tratarEventoDeSalvarAutomatico"
                                        color="primary"/>
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title>
                            <v-checkbox name="Termo de Responsabilidade"
                                        :label="`Declaro para os devidos fins legais, a responsabilidade pelas transações que forem efetuadas no sistema, assumindo como firmes e verdadeiras.`"
                                        v-model="valor.termoResponsabilidade"
                                        v-validate="'required:true'"
                                        :error-messages="errors.collect('Termo de Responsabilidade')"
                                        :disabled="propostaEnviada"
                                        @change="tratarEventoDeSalvarAutomatico"
                                        color="primary"/>
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title>
                            <v-checkbox name="Declaração Comprimento da Lei"
                                        :label="`Declaro o cumprimento do disposto no inciso VI do art. 68 da Lei nº 14.133, de 2021.`"
                                        v-model="valor.termoIncisoVI14133A68"
                                        v-validate="'required:true'"
                                        :error-messages="errors.collect('Declaração Comprimento da Lei')"
                                        :disabled="propostaEnviada"
                                        @change="tratarEventoDeSalvarAutomatico"
                                        color="primary"/>
                        </v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile class="lista">
                    <v-list-tile-content>
                        <v-list-tile-title>
                            <span class="bolinha">2</span>
                            Declaração {{formatarLista(portes) | azConcat}}
                            <span class="red--text">*</span>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                            <p>
                              A licitante é uma microempresa ou empresa de pequeno porte, devidamente enquadrada nos termos da legislação vigente.
                              Portanto, confirma que no ano-calendário de realização do presente certame não celebrou contratos com a Administração Pública
                              cujos valores somados extrapolem a receita bruta máxima admitida para fins de enquadramento como empresa de pequeno porte,
                              conforme definido na Lei Complementar nº 123, de 14 de dezembro de 2006.
                              Declaro ainda estar ciente de que o não cumprimento das disposições legais acima referidas pode acarretar na inabilitação da empresa
                              nesta dispensa de licitação, bem como outras sanções previstas na legislação.
                            </p>
                            <v-radio-group row name="Declaração ME/EPP/MEI"
                                           v-model="valor.possuiPorte"
                                           v-validate="'required'"
                                           :error-messages="errors.collect('Declaração ME/EPP/MEI')"
                                           :disabled="propostaEnviada"
                                           @change="tratarEventoDeSalvarAutomatico">
                                <v-radio label="Sim" :value="true" color="primary"></v-radio>
                                <v-radio label="Não" :value="false" color="primary"></v-radio>
                            </v-radio-group>
                        </v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile class="lista">
                    <v-list-tile-content>
                        <v-list-tile-title>
                            <span class="bolinha">3</span>
                                Declaração de Não Parentesco
                            <span class="red--text">*</span>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                            <p>
                                Declaro na forma do art. 2º inciso VI da Resolução nº 7/2005, de 18 de outubro de 2005,
                                com a redação dada pela Resolução nº 229/2016, de 22 de junho de 2016, ambas do Conselho
                                Nacional de Justiça (CNJ), que não possui em seu quadro societário cônjuge, companheiro ou
                                parente em linha reta, colateral ou por afinidade até o terceiro grau, inclusive, dos magistrados
                                ocupantes de cargos de direção ou no exercício de funções administrativas, assim como de servidores
                                ocupantes de cargos de direção, chefia e assessoramento vinculados direta ou indiretamente às
                                unidades situadas na linha hierárquica da área encarregada da licitação.
                            </p>
                            <v-radio-group row name="Declaração de Não Parentesco"
                                           v-model="valor.termoNaoParentesco"
                                           v-validate="'required'"
                                           :error-messages="errors.collect('Declaração de Não Parentesco')"
                                           :disabled="propostaEnviada"
                                           @change="tratarEventoDeSalvarAutomatico">
                              <v-radio label="Sim" :value="true" color="primary"></v-radio>
                              <v-radio label="Não" :value="false" color="primary"></v-radio>
                            </v-radio-group>
                        </v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile class="lista">
                    <v-list-tile-content>
                        <v-list-tile-title>
                            <span class="bolinha">4</span>
                            Prazo de Validade da Proposta
                            <span class="red--text">*</span>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <label><strong class="primary--text">Validade da Proposta (em dias)</strong></label>
                            <v-flex xs12 sm4 d-flex>
                                <v-text-field name="Validade da Proposta"
                                              placeholder="Ex. 60"
                                              :error-messages="errors.collect('Validade da Proposta')"
                                              v-model.number="valor.validadeProposta"
                                              @keydown="limparStringDigitada($event)"
                                              v-validate="'integer|required|max:9|min_value:1'"
                                              :disabled="propostaEnviada"
                                              @change="tratarEventoDeSalvarAutomatico"/>
                            </v-flex>
                        </v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile class="lista">
                    <v-list-tile-content>
                        <v-list-tile-title>
                            <span class="bolinha">5</span>
                            Prazo de Garantia
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <label><strong class="primary--text">Prazo de garantia (em dias)</strong></label>
                            <v-flex xs12 sm4 d-flex>
                                <v-text-field name="Prazo de Garantia"
                                              placeholder="Ex. 120"
                                              :error-messages="errors.collect('Prazo de Garantia')"
                                              v-model.number="valor.prazoGarantia"
                                              @keydown="limparStringDigitada($event)"
                                              v-validate="'integer|max:9|min_value:0'"
                                              :disabled="propostaEnviada"
                                              @change="tratarEventoDeSalvarAutomatico"/>
                            </v-flex>
                        </v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile class="lista">
                    <v-list-tile-content>
                        <v-list-tile-title>
                            <span class="bolinha">6</span>
                            Prazo de Entrega dos Produtos/Serviços
                            <span class="red--text">*</span>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <label><strong class="primary--text">Prazo de Entrega (em dias)</strong></label>
                            <v-flex xs12 sm4 d-flex>
                              <v-text-field
                                  filled
                                  placeholder="Ex. 10"
                                  name="Prazo de Entrega"
                                  maxlength="100"
                                  v-model.number="valor.prazoEntregaDescritivo"
                                  @keydown="limparStringDigitada($event)"
                                  :error-messages="errors.collect('Prazo de Entrega')"
                                  v-validate="'integer|required|min_value:0'"
                                  :disabled="propostaEnviada"
                                  @change="tratarEventoDeSalvarAutomatico"
                              ></v-text-field>
                            </v-flex>
                        </v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-flex>

        <div class="az-actions-form acao-botao">
            <botao-voltar @voltar="tratarEventoVoltar"/>
            <botao-salvar-avancar @salvarEAvancar="tratarEventoDeAvancar" v-if="!propostaEnviada"/>
            <botao-avancar id="botaoAvancar" @avancar="irParaProposta" v-else/>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import {actionTypes} from '@/core/constants'

export default {
    name: 'Termo',
    data() {
        return {
            valor: {},
            compraDiretaId: null,
            propostaId: null
        }
    },
    $_veeValidate: {
        validator: 'new'
    },
    async mounted() {
        try {
            this.setCompraDiretaId()
            await this.buscarTermos()
            this.desabilitarLoadingGlobal()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    computed: {
        ...mapState(['resumoProposta']),
        propostaEnviada() {
            if (this.resumoProposta.tipo === 'SEM_DISPUTA' && this.resumoProposta.situacaoProposta === 'ENVIADA') {
                return true
            } else if (this.resumoProposta.tipo === 'SEM_DISPUTA' && this.resumoProposta.situacaoProposta === 'EM_ELABORACAO') {
                return false
            } else if (this.resumoProposta.tipo === 'COM_DISPUTA' && this.resumoProposta.situacaoProposta === 'EM_ELABORACAO' && !this.resumoProposta.tempoRandomico) {
                return false
            } else if (this.resumoProposta.tipo === 'COM_DISPUTA' && this.resumoProposta.situacaoProposta === 'ENVIADA' && !this.resumoProposta.tempoRandomico) {
                return true
            } else {
                return this.resumoProposta.tipo === 'COM_DISPUTA' && this.resumoProposta.tempoRandomico
            }
        }
    },
    methods: {
        async buscarTermos() {
            await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_TERMOS, this.compraDiretaId)
            this.valor = this.$store.state.termos
        },
        async tratarEventoDeSalvarAutomatico() {
            this.valor.salvarAutomatico = true
            await this.salvar()
        },
        async tratarEventoDeAvancar() {
            await this.validarCamposObrigatorios()
            this.habilitarLoadingGlobal()
            this.valor.salvarAutomatico = false
            await this.salvar()
            this.mostrarNotificacaoSucesso('Informações salva com sucesso!')
            this.irParaProposta()
        },
        async salvar() {
            const termosObj = {
                compraDiretaId: this.compraDiretaId,
                propostaId: this.propostaId,
                termos: this.valor
            }
            await this.$store.dispatch(actionTypes.FORNECEDOR.SALVAR_TERMOS, termosObj)
        },
        irParaProposta() {
            this.$router.push({
                name: 'PropostaDoFornecedor',
                params: {
                    id: this.compraDiretaId,
                    propostaId: this.propostaId
                }
            })
        },
        async validarCamposObrigatorios() {
            const estaValido = await this.$validator._base.validateAll()
            if (!estaValido) {
                throw new Error('Preencha os campos obrigatórios.')
            }
        },
        setCompraDiretaId() {
            this.compraDiretaId = this.$route.params.id
            this.propostaId = this.$route.params.propostaId
        },
        tratarEventoVoltar() {
            this.$router.push({name: 'DetalhesCompraDireta'})
        },
        limparStringDigitada(evento){
            const teclasAceitaveis = ['Backspace', 'Delete', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown','Enter', 'Tab']
            if ((evento.keyCode < 48 || evento.keyCode > 57) && !this.ehTeclaNumerica(evento) && !teclasAceitaveis.includes(evento.key))
            {
                evento.preventDefault()
            }
        },
        ehTeclaNumerica(evento){
            return [96, 97, 98, 99, 100, 101, 102, 103, 104, 105].includes(evento.keyCode)
        }
    },
}
</script>

<style lang="stylus">
    .bolinha
        width 30px
        min-width 30px
        height 30px
        background-color #ebebeb
        display inline-block
        text-align center
        line-height 30px
        border-radius 50%
        margin-right 10px
        color #777
        font-weight bold

    .lista
        border-bottom 1px solid #ebebeb
        padding 0.6rem 0

        &:last-child
            border-bottom 0

        .v-list__tile
            min-height 70px
            height auto

        .v-list__tile__title
            height auto
            padding-bottom 5px
            font-weight bold
            font-size 16px

        .v-input--selection-controls
            margin-top 0
            padding-top 0

        .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot
            margin-bottom 0

        .v-list__tile__sub-title
            padding 0 40px
            box-sizing border-box
            font-size 15px !important

        .v-list__tile__sub-title, .v-list__tile__title
            white-space normal

        .v-input--selection-controls__input, .v-label
            font-size 15px

        .v-text-field__slot .v-label
            font-size 16px !important

        .v-text-field
            padding-top 0
            margin-top 4px

        .v-input--is-disabled .v-input__slot
            background-color #ebebeb

    .acao-botao
        padding 0
        border-top 1px solid #ebebeb
        padding-top 20px
        align-items center

        .action-primary
            margin 0

    @media only screen and (max-width 959px)
        .passos .v-stepper:not(.v-stepper--vertical) .v-stepper__label
            display block

    @media (max-width 500px)
        .lista .v-list__tile
            padding 0 10px

            &__title, &__sub-title
                font-size 14px

            &__sub-title
                padding 0

        .bolinha
            margin-right 5px
</style>
